// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const PrimitiveTypeV2 = {
    integer: (value) => {
        return Object.assign(Object.assign({}, value), { type: "integer", _visit: function (visitor) {
                return FernIr.PrimitiveTypeV2._visit(this, visitor);
            } });
    },
    long: (value) => {
        return Object.assign(Object.assign({}, value), { type: "long", _visit: function (visitor) {
                return FernIr.PrimitiveTypeV2._visit(this, visitor);
            } });
    },
    uint: (value) => {
        return Object.assign(Object.assign({}, value), { type: "uint", _visit: function (visitor) {
                return FernIr.PrimitiveTypeV2._visit(this, visitor);
            } });
    },
    uint64: (value) => {
        return Object.assign(Object.assign({}, value), { type: "uint64", _visit: function (visitor) {
                return FernIr.PrimitiveTypeV2._visit(this, visitor);
            } });
    },
    float: (value) => {
        return Object.assign(Object.assign({}, value), { type: "float", _visit: function (visitor) {
                return FernIr.PrimitiveTypeV2._visit(this, visitor);
            } });
    },
    double: (value) => {
        return Object.assign(Object.assign({}, value), { type: "double", _visit: function (visitor) {
                return FernIr.PrimitiveTypeV2._visit(this, visitor);
            } });
    },
    boolean: (value) => {
        return Object.assign(Object.assign({}, value), { type: "boolean", _visit: function (visitor) {
                return FernIr.PrimitiveTypeV2._visit(this, visitor);
            } });
    },
    string: (value) => {
        return Object.assign(Object.assign({}, value), { type: "string", _visit: function (visitor) {
                return FernIr.PrimitiveTypeV2._visit(this, visitor);
            } });
    },
    date: (value) => {
        return Object.assign(Object.assign({}, value), { type: "date", _visit: function (visitor) {
                return FernIr.PrimitiveTypeV2._visit(this, visitor);
            } });
    },
    dateTime: (value) => {
        return Object.assign(Object.assign({}, value), { type: "dateTime", _visit: function (visitor) {
                return FernIr.PrimitiveTypeV2._visit(this, visitor);
            } });
    },
    dateTimeRfc2822: (value) => {
        return Object.assign(Object.assign({}, value), { type: "dateTimeRfc2822", _visit: function (visitor) {
                return FernIr.PrimitiveTypeV2._visit(this, visitor);
            } });
    },
    uuid: (value) => {
        return Object.assign(Object.assign({}, value), { type: "uuid", _visit: function (visitor) {
                return FernIr.PrimitiveTypeV2._visit(this, visitor);
            } });
    },
    base64: (value) => {
        return Object.assign(Object.assign({}, value), { type: "base64", _visit: function (visitor) {
                return FernIr.PrimitiveTypeV2._visit(this, visitor);
            } });
    },
    bigInteger: (value) => {
        return Object.assign(Object.assign({}, value), { type: "bigInteger", _visit: function (visitor) {
                return FernIr.PrimitiveTypeV2._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "integer":
                return visitor.integer(value);
            case "long":
                return visitor.long(value);
            case "uint":
                return visitor.uint(value);
            case "uint64":
                return visitor.uint64(value);
            case "float":
                return visitor.float(value);
            case "double":
                return visitor.double(value);
            case "boolean":
                return visitor.boolean(value);
            case "string":
                return visitor.string(value);
            case "date":
                return visitor.date(value);
            case "dateTime":
                return visitor.dateTime(value);
            case "dateTimeRfc2822":
                return visitor.dateTimeRfc2822(value);
            case "uuid":
                return visitor.uuid(value);
            case "base64":
                return visitor.base64(value);
            case "bigInteger":
                return visitor.bigInteger(value);
            default:
                return visitor._other(value);
        }
    },
};
